module.exports = __webpack_public_path__ + "static/Bright.29cfcb8e.png";